import React from 'react';
import { connect } from 'react-redux';
import preRepeatable from '@assets/components/FillWord/pre-repeatable.gif';
import repeatable from '@assets/components/FillWord/repeatable.gif';
import './FillWordLoader.css';

class fillWordLoader extends React.Component {
  constructor() {
    super();
    this.state = {
      hidden: false,
      loader: null,
    };
  }

  /**
   * Подгружаем картинки заранее
   */
  componentWillMount() {
    [preRepeatable, repeatable].forEach((picture) => {
      const img = new Image();
      img.src = picture.fileName;
    });
  }

  componentWillUnmount () {
    if(this.state.loader) {
      clearTimeout(this.state.loader);
      this.setState({
        hidden: true,
      });
    }
  }

  /**
   * Подменяем изображение через заданный интервал
   */
  componentDidMount() {
    this.showLoader();
  }

  showLoader () {
    this.setState({
      loader: setTimeout(()  => {
        this.setState({hidden: true});
      }, 600),
    });
  }

  render() {
    return (
      <div className="loaderBlock">
        <img className={'preRepeatable ' + (this.state.hidden ? 'hidden' : '')} src={preRepeatable} alt=""/>
        <img className="repeatable" src={repeatable} alt=""/>
      </div>
    )
  }
}

export default connect(null, null)(fillWordLoader);